import { Card, Col, Row } from 'react-bootstrap';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ModuleDescription = ({ content }: { content: string }) => {
    const { t } = useTranslation();

    return (
        <Row>
            <Col>
                <Card>
                    <Card.Header className='py-2 bg-primary'>
                        <h4 className='header-title mb-0 text-white fw-bolder'>{t('module.description')}</h4>
                    </Card.Header>
                    <Card.Body>
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default ModuleDescription;
